import React, { useState } from 'react';
import classNames from 'classnames/bind';
import { useDispatch, useSelector } from 'react-redux';
import { IoCloseOutline } from 'react-icons/io5';
import useMountEffect from '@restart/hooks/useMountEffect';
import axios from 'axios';

import { getRuntimeServiceApiKeys, getRuntimeServiceEndpoints } from '../constants/runtimeConfig';
import styles from './Menu.module.scss';
import actions from '../actions';

const cx = classNames.bind(styles);

const Menu = () => {
  const dispatch = useDispatch();
  const id = useSelector((state) => state.auth.id);
  const role = useSelector((state) => state.auth.role);
  const menus = useSelector((state) => state.auth.menus);
  const key = useSelector((state) => state.auth.key);
  const tmsUserRid = useSelector((state) => state.auth.tmsUserRid);
  const [visible, setVisible] = useState(false);
  const serviceApiKeys = getRuntimeServiceApiKeys();
  const serviceEndpoints = getRuntimeServiceEndpoints();

  useMountEffect(() => {
    setTimeout(() => setVisible(true), 10);
  });

  const goSMS = () => {
    if (menus.isSms) {
      window.alert('접근할 권한이 없습니다.');
      return;
    }
    axios
      .get(serviceEndpoints.smsTicketUrl, {
        headers: {
          'x-api-key': key,
        },
      })
      .then((response) => response.data)
      .then(({ success, data }) => {
        if (success) {
          window.open(`${serviceEndpoints.smsWebUrl}/autologin?ticket=${data.ticket}`);
        }
      });
  };

  const goTMS = () => {
    if (menus.isTms) {
      window.alert('접근할 권한이 없습니다.');
      return;
    }
    if (!serviceApiKeys.tms) {
      window.alert('TMS 연동 키가 설정되지 않았습니다. 운영자에게 문의해 주세요.');
      return;
    }
    if (!tmsUserRid) {
      window.alert('TMS 사용자 연동 정보가 설정되지 않았습니다. 운영자에게 문의해 주세요.');
      return;
    }
    axios
      .get(serviceEndpoints.tmsTicketUrl, {
        headers: {
          'x-api-key': serviceApiKeys.tms,
          'x-user-rid': tmsUserRid,
        },
      })
      .then((response) => response.data)
      .then(({ success, data }) => {
        if (success) {
          window.open(`${serviceEndpoints.tmsWebUrl}/autologin?ticket=${data.ticket}`);
        }
      });
  };

  // 로그아웃
  const doLogout = () => {
    localStorage.removeItem('@ims/isLoggedInfo');
    dispatch(actions.auth.logout());
  };

  return (
    <div className={cx(['container', { visible }])}>
      <div className={cx('headerRow')}>
        <div className={cx('brandArea')}>
          <div className={cx('logo')} aria-hidden="true" />
        </div>
        <div className={cx('headerActions')}>
          <div className={cx('userDesc')}>
            <span className={cx('userId')}>{id} 님</span>
            <span className={cx('userRole')}>({role})</span>
          </div>
          <button type="button" className={cx('logoutButton')} onClick={doLogout} aria-label="로그아웃">
            <IoCloseOutline size={24} />
          </button>
        </div>
      </div>
      <div className={cx('wrapper')}>
        <div className={cx('menu', { disabled: menus.isSms })} onClick={goSMS}>
          <div className={cx('title')}>H2SMS</div>
          <div className={cx('subtitle')}>수소스테이션모니터링시스템</div>
          <div className={cx(['image', 'clip1'])} />
        </div>
        <div className={cx('menu', { disabled: menus.isTms })} onClick={goTMS}>
          <div className={cx('title')}>H2TMS</div>
          <div className={cx('subtitle')}>수소용기관리시스템</div>
          <div className={cx(['image', 'clip2'])} />
        </div>
      </div>
    </div>
  );
};

export default Menu;
